<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="success" plain @click="onExport">导出</el-button>
        <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.Status == 2" @click="detailsById(row.OtherReceivId)">查看</el-button>
            <el-button type="text" v-if="row.Status != 2" @click="editById(row.OtherReceivId)">编辑</el-button>
            <el-button type="text" v-if="row.Status != 2" @click="check(row)">审核</el-button>
            <!-- <el-button type="text" v-if="row.Status!=2" @click="delRows(row.DocId)">删除</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px">
      <span>单据明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details" v-loading="isLoading" show-summary>
      <el-table-column label="摘要" align="center" min-width="200">
        <template slot-scope="{ row }">{{ row.Abstract }}</template>
      </el-table-column>
      <el-table-column label="项目" align="center" min-width="140">
        <template slot-scope="{ row }">{{ row.ItemName }}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" align="center" width="120" />
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from '@/mixins/curd'
import list from '@/components/fund/contactcash/orec/list'
import editDialog from '@/components/fund/contactcash/orec/editDialog'
import detailsDialog from '@/components/fund/contactcash/orec/detailsDialog'
export default {
  name: 'receipt',
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog
  },
  data() {
    return {
      api: require('@/api/fund/contactcash/orec').default,
      Details: [],
      isLoading: false
    }
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.list.onExport();
      })
        .catch(() => {});
    },
    reload() {
      this.$refs.list.reload()
      this.Details = []
    },
    onChange(row) {
      this.Details = []
      this.isLoading = true
      this.api.info(row.OtherReceivId).then(res => {
        this.isLoading = false
        if (res.Code == 0) this.Details = res.Data.RpOtherReceivDts
      })
    },
    detailsById(id) {
      this.$refs.detailsDialog.openDetailsById(id)
    },
    check(row) {
      sessionStorage.setItem('check', '1')
      this.$refs.detailsDialog.openEditById(row.OtherReceivId)
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.OtherReceivId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    }
  }
}
</script>
